import React from 'react';
import { useProductDescription } from '../hooks/useProductDescription';
import ProductDescriptionCollapse from './ProductDescriptionCollapse';

const ProductDescriptionText = () => {
	const { blockClass, collapseContent, isOpen } = useProductDescription();
	const [elementHeight, setElementHeight] = React.useState('auto');
	const elementRef = React.useRef(null);

	React.useEffect(() => {
		if (collapseContent) {
			if (elementRef?.current?.scrollHeight > 220) {
				if (isOpen) {
					setElementHeight(elementRef.current.scrollHeight + 60 + 'px');
				} else {
					setElementHeight('220px');
				}
			} else {
				setElementHeight('auto');
			}
		} else {
			setElementHeight('auto');
		}
	}, [isOpen, collapseContent, elementRef]);

	const renderClassContent = () => {
		return blockClass && `content--${blockClass} vtex-store-components-3-x-content--${blockClass}`;
	};
	const renderClassContainer = () => {
		return blockClass && `container--${blockClass} vtex-store-components-3-x-container--${blockClass}`;
	};
	const renderClassText = () => {
		return (
			blockClass &&
			`productDescriptionText--${blockClass} vtex-store-components-3-x-productDescriptionText--${blockClass}`
		);
	};

	return (
		<div
			className={`productDescriptionText vtex-store-components-3-x-productDescriptionText ${renderClassText()} c-muted-1`}
		>
			<div
				className={`container vtex-store-components-3-x-container ${renderClassContainer()} relative`}
				style={{
					transition: 'all 600ms ease-in-out 0s',
					height: elementHeight,
					overflow: 'hidden',
					display: 'block',
				}}
			>
				<div className={`content vtex-store-components-3-x-content ${renderClassContent()} h-auto`}>
					<div style={{ display: 'contents' }}>
						<p ref={elementRef}>
							Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes em Aço Carbono com Acendimento
							superautomático 2 Queimadores da linha Perfecta ficará ainda mais gostoso cozinhar. Além disso, ele é a
							melhor opção para quem deseja levar para o ambiente mais modernidade e sofisticação. E para lhe garantir
							qualidade, durabilidade e praticidade, o cooktop conta com acendimento superautomático, basta pressionar o
							manípulo e girá-lo para que a chama se aina fica fácil transformar a sua casa. Com o Cooktop a Gás
							Tramontina Dominó 2GX 30 em Aço Inox e Trempes em Aço Carbono com Acendimento superautomático 2
							Queimadores da linha Perfecta ficará ainda mais gostoso cozinhar. Além disso, ele é a melhor opção para
							quem deseja levar para o ambiente mais modernidade e sofisticação. E para lhe garantir qualidade,
							durabilidade e praticidade, o cooktop conta com acendimento superautomático, basta pressionar o manípulo e
							girá-lo para que a chama se aina fica fácil transformar a sua casa. Com o Cooktop a Gás Tramontina Dominó
							2GX 30 em Aço Inox e Trempes em Aço Carbono com Acendimento superautomático 2 Queimadores da linha
							Perfecta ficará ainda mais gostoso cozinhar. Além disso, ele é a melhor opção para quem deseja levar para
							o ambiente mais modernidade e sofisticação. E para lhe garantir qualidade, durabilidade e praticidade, o
							cooktop conta com acendimento superautomático, basta pressionar o manípulo e girá-lo para que a chama se
							aina fica fácil transformar a sua casa. Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes
							em Aço Carbono com Acendimento superautomático 2 Queimadores da linha Perfecta ficará ainda mais gostoso
							cozinhar. Além disso, ele é a melhor opção para quem deseja levar para o ambiente mais modernidade e
							sofisticação. E para lhe garantir qualidade, durabilidade e praticidade, o cooktop conta com acendimento
							superautomático, basta pressionar o manípulo e girá-lo para que a chama se aina fica fácil transformar a
							sua casa. Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes em Aço Carbono com
							Acendimento superautomático 2 Queimadores da linha Perfecta ficará ainda mais gostoso cozinhar. Além
							disso, ele é a melhor opção para quem deseja levar para o ambiente mais modernidade e sofisticação. E para
							lhe garantir qualidade, durabilidade e praticidade; Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço
							Inox e Trempes em Aço Carbono com Acendimento superautomático 2 Queimadores da linha Perfecta ficará ainda
							mais gostoso cozinhar. Além disso, ele é a melhor opção para quem deseja levar para o ambiente mais
							modernidade e sofisticação. E para lhe garantir qualidade, durabilidade e praticidade, o cooktop conta com
							acendimento superautomático, basta pressionar o manípulo e girá-lo para que a chama se aina fica fácil
							transformar a sua casa. Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes em Aço Carbono
							com Acendimento superautomático 2 Queimadores da linha Perfecta ficará ainda mais gostoso cozinhar. Além
							disso, ele é a melhor opção para quem deseja levar para o ambiente mais modernidade e sofisticação. E para
							lhe garantir qualidade, durabilidade e praticidade, o cooktop conta com acendimento superautomático, basta
							pressionar o manípulo e girá-lo para que a chama se aina fica fácil transformar a sua casa. Com o Cooktop
							a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes em Aço Carbono com Acendimento superautomático 2
							Queimadores da linha Perfecta ficará ainda mais gostoso cozinhar. Além disso, ele é a melhor opção para
							quem deseja levar para o ambiente mais modernidade e sofisticação. E para lhe garantir qualidade,
							durabilidade e praticidade, o cooktop conta com acendimento superautomático, basta pressionar o manípulo e
							girá-lo para que a chama se aina fica fácil transformar a sua casa. Com o Cooktop a Gás Tramontina Dominó
							2GX 30 em Aço Inox e Trempes em Aço Carbono com Acendimento superautomático 2 Queimadores da linha
							Perfecta ficará ainda mais gostoso cozinhar. Além disso, ele é a melhor opção para quem deseja levar para
							o ambiente mais modernidade e sofisticação. E para lhe garantir qualidade, durabilidade e praticidade, o
							cooktop conta com acendimento superautomático, basta pressionar o manípulo e girá-lo para que a chama se
							aina fica fácil transformar a sua casa. Com o Cooktop a Gás Tramontina Dominó 2GX 30 em Aço Inox e Trempes
							em Aço Carbono com Acendimento superautomático 2 Queimadores da linha Perfecta ficará ainda mais gostoso
							cozinhar. Além disso, ele é a melhor opção para quem deseja levar para o ambiente mais modernidade e
							sofisticação. E para lhe garantir qualidade, durabilidade e praticidade
						</p>
					</div>
				</div>
				<ProductDescriptionCollapse elementHeight={elementHeight} />
			</div>
		</div>
	);
};

export default ProductDescriptionText;
